// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useShellStore } from '../../stores/shellStore';
import { STATIC_SITES } from '../../config/sites';
import { useAuth } from '../../hooks/useAuth';

/**
 * Syncs the site_id from the URL route params into the shell store.
 * Rendered inside the route tree so useParams() has access to :site_id.
 * Handles browser back/forward keeping the DC selector in sync.
 */
function SiteRouteSync() {
  const { site_id } = useParams<{ site_id: string }>();
  const selectedSiteId = useShellStore(s => s.selectedSiteId);
  const setSelectedSite = useShellStore(s => s.setSelectedSite);
  const { sites } = useAuth();

  useEffect(() => {
    if (!site_id || site_id === selectedSiteId) return;

    // Try to find the site name from auth context first, then static sites
    const fromAuth = sites.find(s => s.site_id === site_id);
    if (fromAuth) {
      setSelectedSite(site_id, fromAuth.label);
      return;
    }

    const fromStatic = STATIC_SITES.find(s => s.id === site_id);
    setSelectedSite(site_id, fromStatic?.label ?? site_id);
  }, [site_id, selectedSiteId, sites, setSelectedSite]);

  return null;
}

export default SiteRouteSync;
